var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frow form-section column-start mb-25 width-100"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(!_vm.printOut)?_c('span',[_vm._v("- "+_vm._s(_vm.description))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }